/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Answer,
  ComplianceChecklist,
  PaginatedAnswerList,
  PaginatedComplianceChecklistList,
  PatchedAnswer,
} from '../models/index';
import {
    AnswerFromJSON,
    AnswerToJSON,
    ComplianceChecklistFromJSON,
    ComplianceChecklistToJSON,
    PaginatedAnswerListFromJSON,
    PaginatedAnswerListToJSON,
    PaginatedComplianceChecklistListFromJSON,
    PaginatedComplianceChecklistListToJSON,
    PatchedAnswerFromJSON,
    PatchedAnswerToJSON,
} from '../models/index';

export interface NacsaAnswersCreateRequest {
    teamSlug: string;
    answer: Omit<Answer, 'id'|'element_score'|'global_score'>;
}

export interface NacsaAnswersDestroyRequest {
    id: string;
    teamSlug: string;
}

export interface NacsaAnswersListRequest {
    teamSlug: string;
    limit?: number;
    page?: number;
}

export interface NacsaAnswersPartialUpdateRequest {
    id: string;
    teamSlug: string;
    patchedAnswer?: Omit<PatchedAnswer, 'id'|'element_score'|'global_score'>;
}

export interface NacsaAnswersRetrieveRequest {
    id: string;
    teamSlug: string;
}

export interface NacsaAnswersUpdateRequest {
    id: string;
    teamSlug: string;
    answer: Omit<Answer, 'id'|'element_score'|'global_score'>;
}

export interface NacsaComplianceChecklistListRequest {
    teamSlug: string;
    limit?: number;
    page?: number;
}

export interface NacsaComplianceChecklistRetrieveRequest {
    id: number;
    teamSlug: string;
}

/**
 * 
 */
export class NacsaApi extends runtime.BaseAPI {

    /**
     * Endpoint for submitting answers. Supports single and bulk answer creation. Each question must have only one answer per team; if an answer exists, it is updated. After saving (or updating) an answer, the corresponding element score for the team is recalculated.
     */
    async nacsaAnswersCreateRaw(requestParameters: NacsaAnswersCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Answer>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling nacsaAnswersCreate().'
            );
        }

        if (requestParameters['answer'] == null) {
            throw new runtime.RequiredError(
                'answer',
                'Required parameter "answer" was null or undefined when calling nacsaAnswersCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/nacsa/{team_slug}/answers/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AnswerToJSON(requestParameters['answer']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AnswerFromJSON(jsonValue));
    }

    /**
     * Endpoint for submitting answers. Supports single and bulk answer creation. Each question must have only one answer per team; if an answer exists, it is updated. After saving (or updating) an answer, the corresponding element score for the team is recalculated.
     */
    async nacsaAnswersCreate(requestParameters: NacsaAnswersCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Answer> {
        const response = await this.nacsaAnswersCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Endpoint for submitting answers. Supports single and bulk answer creation. Each question must have only one answer per team; if an answer exists, it is updated. After saving (or updating) an answer, the corresponding element score for the team is recalculated.
     */
    async nacsaAnswersDestroyRaw(requestParameters: NacsaAnswersDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling nacsaAnswersDestroy().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling nacsaAnswersDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/nacsa/{team_slug}/answers/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Endpoint for submitting answers. Supports single and bulk answer creation. Each question must have only one answer per team; if an answer exists, it is updated. After saving (or updating) an answer, the corresponding element score for the team is recalculated.
     */
    async nacsaAnswersDestroy(requestParameters: NacsaAnswersDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.nacsaAnswersDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * Endpoint for submitting answers. Supports single and bulk answer creation. Each question must have only one answer per team; if an answer exists, it is updated. After saving (or updating) an answer, the corresponding element score for the team is recalculated.
     */
    async nacsaAnswersListRaw(requestParameters: NacsaAnswersListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedAnswerList>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling nacsaAnswersList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/nacsa/{team_slug}/answers/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedAnswerListFromJSON(jsonValue));
    }

    /**
     * Endpoint for submitting answers. Supports single and bulk answer creation. Each question must have only one answer per team; if an answer exists, it is updated. After saving (or updating) an answer, the corresponding element score for the team is recalculated.
     */
    async nacsaAnswersList(requestParameters: NacsaAnswersListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedAnswerList> {
        const response = await this.nacsaAnswersListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Endpoint for submitting answers. Supports single and bulk answer creation. Each question must have only one answer per team; if an answer exists, it is updated. After saving (or updating) an answer, the corresponding element score for the team is recalculated.
     */
    async nacsaAnswersPartialUpdateRaw(requestParameters: NacsaAnswersPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Answer>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling nacsaAnswersPartialUpdate().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling nacsaAnswersPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/nacsa/{team_slug}/answers/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedAnswerToJSON(requestParameters['patchedAnswer']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AnswerFromJSON(jsonValue));
    }

    /**
     * Endpoint for submitting answers. Supports single and bulk answer creation. Each question must have only one answer per team; if an answer exists, it is updated. After saving (or updating) an answer, the corresponding element score for the team is recalculated.
     */
    async nacsaAnswersPartialUpdate(requestParameters: NacsaAnswersPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Answer> {
        const response = await this.nacsaAnswersPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Endpoint for submitting answers. Supports single and bulk answer creation. Each question must have only one answer per team; if an answer exists, it is updated. After saving (or updating) an answer, the corresponding element score for the team is recalculated.
     */
    async nacsaAnswersRetrieveRaw(requestParameters: NacsaAnswersRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Answer>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling nacsaAnswersRetrieve().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling nacsaAnswersRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/nacsa/{team_slug}/answers/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AnswerFromJSON(jsonValue));
    }

    /**
     * Endpoint for submitting answers. Supports single and bulk answer creation. Each question must have only one answer per team; if an answer exists, it is updated. After saving (or updating) an answer, the corresponding element score for the team is recalculated.
     */
    async nacsaAnswersRetrieve(requestParameters: NacsaAnswersRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Answer> {
        const response = await this.nacsaAnswersRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Endpoint for submitting answers. Supports single and bulk answer creation. Each question must have only one answer per team; if an answer exists, it is updated. After saving (or updating) an answer, the corresponding element score for the team is recalculated.
     */
    async nacsaAnswersUpdateRaw(requestParameters: NacsaAnswersUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Answer>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling nacsaAnswersUpdate().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling nacsaAnswersUpdate().'
            );
        }

        if (requestParameters['answer'] == null) {
            throw new runtime.RequiredError(
                'answer',
                'Required parameter "answer" was null or undefined when calling nacsaAnswersUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/nacsa/{team_slug}/answers/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AnswerToJSON(requestParameters['answer']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AnswerFromJSON(jsonValue));
    }

    /**
     * Endpoint for submitting answers. Supports single and bulk answer creation. Each question must have only one answer per team; if an answer exists, it is updated. After saving (or updating) an answer, the corresponding element score for the team is recalculated.
     */
    async nacsaAnswersUpdate(requestParameters: NacsaAnswersUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Answer> {
        const response = await this.nacsaAnswersUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns all elements with nested questions (each including the team\'s answer) and team score. If a question is unanswered, it returns a default answer (\"no\"). If a score is not set, returns False.
     */
    async nacsaComplianceChecklistListRaw(requestParameters: NacsaComplianceChecklistListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedComplianceChecklistList>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling nacsaComplianceChecklistList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/nacsa/{team_slug}/compliance-checklist/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedComplianceChecklistListFromJSON(jsonValue));
    }

    /**
     * Returns all elements with nested questions (each including the team\'s answer) and team score. If a question is unanswered, it returns a default answer (\"no\"). If a score is not set, returns False.
     */
    async nacsaComplianceChecklistList(requestParameters: NacsaComplianceChecklistListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedComplianceChecklistList> {
        const response = await this.nacsaComplianceChecklistListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns all elements with nested questions (each including the team\'s answer) and team score. If a question is unanswered, it returns a default answer (\"no\"). If a score is not set, returns False.
     */
    async nacsaComplianceChecklistRetrieveRaw(requestParameters: NacsaComplianceChecklistRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ComplianceChecklist>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling nacsaComplianceChecklistRetrieve().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling nacsaComplianceChecklistRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/nacsa/{team_slug}/compliance-checklist/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ComplianceChecklistFromJSON(jsonValue));
    }

    /**
     * Returns all elements with nested questions (each including the team\'s answer) and team score. If a question is unanswered, it returns a default answer (\"no\"). If a score is not set, returns False.
     */
    async nacsaComplianceChecklistRetrieve(requestParameters: NacsaComplianceChecklistRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ComplianceChecklist> {
        const response = await this.nacsaComplianceChecklistRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
